import axios from "axios";
import { ACCESS_TOKEN, getToken, USER_KEY } from "utility/auth";
export const NEXT_BASE_URL = "https://api.pionecare.com/";
export const BULK_UPLOAD_URL = "https://file.pionecare.com/"; // link up img
// export const NEXT_BASE_URL = "http://192.168.1.27:8231/";
// export const BULK_UPLOAD_URL = "http://192.168.0.153:3333/"; // link up img

const API = axios.create({
  baseURL: NEXT_BASE_URL,
});

const API_IMG = axios.create({
  baseURL: BULK_UPLOAD_URL,
});

export const token = getToken();

API.interceptors.request.use((req) => {
  if (token) {
    req.headers.token = `EG ${token}`;
  }
  return req;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(USER_KEY);
      localStorage.removeItem(ACCESS_TOKEN);
      setTimeout(() => {
        window.location.href = "/";
      }, 9999);
    }
    return Promise.reject(error);
  }
);

// file image
export const FileImageService = {
  doBulkUpload: (data) => API_IMG.post("/api/v1/file/single-upload", data),
};

//auth
export const AuthService = {
  doLogin: (data) => API.post("api/v1/user/authentication/login01", data),
  doRegister: (data) => API.post("api/v1/user/authentication/register", data),
  doForgot: (data) => API.post("api/v1/user/authentication/forgotPass", data),
  doVerifyEmailpass: (data) =>
    API.post("api/v1/user/authentication/verifyEmailpass", data),
  doChangePass: (data) =>
    API.post("api/v1/user/authentication/changePass", data),
  doDeleteAccount: (data) => {
    const { password } = data;
    return API.delete("api/v1/user/authentication/delete_account", {
      data: { password },
    });
  },

  doDeleteTypeAccount: (data) =>
    API.delete("api/v1/user/authentication/delete_type_account", { data }),
};

//MissionService
export const MissionService = {
  doGetInfoMission: () => API.get("api/v1/user/wallet/mission"),
  doGetListConstant: () => API.get("api/v1/user/checkWallet/list-constant"),
};

// information user
export const InformationService = {
  doGetListProfile: () => API.get("api/v1/user/info/getlistprofile"),
  doEditProfile: (data) => API.put("api/v1/user/info/updateProfile", data),
  doGetListCountry: () => API.get("api/v1/user/info/listAddress?level=country"),
  doGetListProvince: (parent) =>
    API.get(`api/v1/user/info/listAddress?level=province&parent=${parent}`),

  // doGetListAddress: (data = {}) => {
  //   const { parent = 0, level = "" } = data;
  //   const levelFil = level === "" ? "" : `level=${level}`;
  //   const parentFil = level === "country" ? "" : `&parent=${parent}`;
  //   const query = [levelFil, parentFil].filter(Boolean).join("");

  //   const url = query
  //     ? `api/v1/user/info/listAddress?${query}`
  //     : `api/v1/user/info/listAddress?`;
  //   return API.get(url);
  // },
};

// specialtySlice
export const SpecialtySliceService = {
  // doGetListSpecialty: (data = {}) => {
  //   const { keyword = "" } = data;
  //   const keywordFil = keyword ? `keyword=${keyword}` : "";
  //   const query = [keywordFil].filter(Boolean).join("&");

  //   const url = query
  //     ? `api/v1/user/common/list-specialty?${query}`
  //     : `api/v1/user/common/list-specialty`;

  //   return API.get(url);
  // },
  doGetListSpecialty: (keyword) =>
    API.get(`api/v1/user/common/list-specialty?keyword=${keyword}&limit=9999`),
  doGetListMedicalFacility: (keyword) =>
    API.get(`api/v1/user/common/list-medical-facility?keyword=${keyword}`),
  doGetDetailMedicalFacility: (facilityId) => {
    return API.get(`api/v1/user/common/detail-medical-facility/${facilityId}`);
  },
  doGetDetailDoctorSpecialty: (data) => {
    return API.get(`api/v1/user/common/detail-doctor-specialty/${data?.id}`);
  },
  doCreateMedicalFacility: (data) =>
    API.post("api/v1/user/common/create", data),
  doUpdateMedicalFacility: (payload) =>
    API.put(`api/v1/user/common/update/${payload?.id}`, payload.data),

  doGetListMedicalFacilityUser: () =>
    API.get("api/v1/user/common/list-medical-facility-user"),
  doDelMedicalFacilityUser: (data) =>
    API.delete(`api/v1/user/common/delete-medical-facility-user/${data?.id}`),
  // api/v1/user/common/delete-medical-facility-user/34
};

// doctor
export const DoctorService = {
  // doctor profile
  doCreateInfo: (data) => API.post("api/v1/user/doctor/create-info", data),
  doUpdateInfo: (data) => API.put("api/v1/user/doctor/update-info", data),
  doGetAllDoctor: (data = {}) => {
    const {
      keyword = "",
      country_id = 0,
      specialty_id = 0,
      facility_id = 0,
      type = "",
      date_start = "",
      date_end = "",
    } = data;
    const keyword_fil = keyword === "" ? "" : `keyword=${keyword}`;
    const type_fil = type === "" ? "" : `&type=${type}`;
    const country_id_fil = country_id === 0 ? "" : `&country_id=${country_id}`;
    const specialty_id_fil =
      specialty_id === 0 ? "" : `&specialty_id=${specialty_id}`;
    const facility_id_fil =
      facility_id === 0 ? "" : `&facility_id=${facility_id}`;

    const date_fil =
      date_start === "" && date_end === ""
        ? ""
        : `&date_start=${date_start}&date_end=${date_end}`;

    const query = [
      date_fil,
      facility_id_fil,
      keyword_fil,
      type_fil,
      country_id_fil,
      specialty_id_fil,
    ]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/doctor/get-all-doctor?${query}`
      : `api/v1/user/doctor/get-all-doctor`;

    return API.get(url);
  },
  doGetDetailDoctor: (data) =>
    API.get(`api/v1/user/doctor/detail_doctor/${data?.id}`),
  // /api/v1/user/doctor/search-dateWorking-doctor/23?date=2024-11-08
  doGetSearchDateWorkingDoctor: (data) =>
    API.get(
      `api/v1/user/doctor/search-dateWorking-doctor/${data?.id}?date=${data?.date}`
    ),

  // doctor working
  doGetDateWorkingDoctor: (data = {}) => {
    const { date_start = "", date_end = "", type = "", status = "" } = data;
    const date_start_fil = date_start === "" ? "" : `&date_start=${date_start}`;
    const date_end_fil = date_end === "" ? "" : `&date_end=${date_end}`;
    const status_fil = status === "" ? "" : `&status=${status}`;
    const type_fil = type === "" ? "" : `&type=${type}`;
    // const type_fil = type === null ? "" : `&type=${type}`;
    // const status_fil = status === null ? "" : `&status=${status}`;

    const query = [date_start_fil, date_end_fil, status_fil, type_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/doctor/get-date-working-doctor?limit=9999${query}`
      : `api/v1/user/doctor/get-date-working-doctor?limit=9999`;

    return API.get(url);
  },
  doCreateDateWorking: (data) =>
    API.post("api/v1/user/doctor/create-date-working", data),
  doUpdateDateWorking: (id, data) =>
    API.put(`api/v1/user/doctor/update-date-working/${id}`, data),
  doDeleteDateWorking: (id) =>
    API.delete(`api/v1/user/doctor/delete-date-working/${id}`),
  // doctor price
  doGetExaminationPrice: (data) =>
    API.get("api/v1/user/doctor/get-examination-price", data),
  doCreateExaminationPriceChild: (data) =>
    API.post("api/v1/user/doctor/create-service-price", data),
  doUpdateExaminationPriceChild: (id, data) =>
    API.put(`api/v1/user/doctor/update-service-price/${id}`, data),
  doDeleteExaminationPriceChild: (id) =>
    API.delete(`api/v1/user/doctor/delete-service-price/${id}`),
  doCreateExaminationPrice: (data) =>
    API.post("api/v1/user/doctor/create-examination-price", data),
  doUpdateExaminationPrice: (id, data) =>
    API.put(`api/v1/user/doctor/update-examination-price/${id}`, data),
  doDeleteExaminationPrice: (id) =>
    API.delete(`api/v1/user/doctor/delete-examination-price/${id}`),
};

// cooperate
export const CooperateService = {
  doGetListContactCooperate: (data) =>
    API.get("api/v1/user/common/list-contact-cooperate", data),
  doContactRegister: (data) =>
    API.post("api/v1/user/common/contact-register", data),
  doUpdateContactCooperate: (data) =>
    API.put(`api/v1/user/common/update-contact-cooperate/${data?.id}`, data),
};

// relationship
export const RelationshipService = {
  doCreateRelative: (data) => API.post("api/v1/user/relative/create", data),
  doGetListRelationship: (data) =>
    API.get("api/v1/user/relative/list-relationship", data),
  // doUpdateRelationship: (data) =>
  //   API.put(`api/v1/user/relative/update/${data?.id}`, data),
  doUpdateRelationship: (data) => {
    const { id, ...restData } = data;
    return API.put(`api/v1/user/relative/update/${id}`, restData);
  },

  doDeleteRelationship: (id) =>
    API.delete(`api/v1/user/relative/delete-relationship/${id}`),
};

export const AppointmentService = {
  doCreateBooking: (data) =>
    API.post("api/v1/user/booking/order/create-booking", data),

  doGetHistoryBookingDoctor: (data = {}) => {
    const { type = "", date_start = "", date_end = "" } = data;
    const type_fil = type === "" ? "" : `type=${type}`;
    const date_start_fil = date_start === "" ? "" : `&date_start=${date_start}`;
    const date_end_fil = date_end === "" ? "" : `&date_end=${date_end}`;

    const query = [type_fil, date_start_fil, date_end_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/booking/order/history-booking-doctor?limit=9999&${query}`
      : `api/v1/user/booking/order/history-booking-doctor?limit=9999`;

    return API.get(url);
  },

  doCheckQuery: (data) =>
    API.post("api/v1/user/booking/order/check-query", data),

  doGetHistoryBookingUser: (data = {}) => {
    const {
      type = "",
      date_start = "",
      date_end = "",
      specialty_id = 0,
    } = data;
    const type_fil = type === "" ? "" : `type=${type}`;
    const date_start_fil = date_start === "" ? "" : `&date_start=${date_start}`;
    const date_end_fil = date_end === "" ? "" : `&date_end=${date_end}`;
    const specialty_id_fil =
      specialty_id === 0 ? "" : `&specialty_id=${specialty_id}`;

    const query = [type_fil, date_start_fil, date_end_fil, specialty_id_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/booking/order/history-booking-user?limit=9999&${query}`
      : `api/v1/user/booking/order/history-booking-user?limit=9999`;

    return API.get(url);
  },
  doCancelBookingUser: (data) =>
    API.put(`api/v1/user/booking/order/cancel-booking-user/${data?.id}`, data),
};

export const ReviewService = {
  doCreateReview: (data) => API.post("api/v1/user/review/create", data),
};

export const DepositService = {
  doGetListMethod: () => API.get("api/v1/user/deposit/list-method"),
  doGetListCurrency: (data) => {
    const query = data?.keyword ? `&keyword=${data.keyword}` : "";
    return API.get(`api/v1/user/deposit/list-currency?limit=999${query}`);
  },
  doInitialOrder: (data) => API.post("api/v1/user/deposit/initial-order", data),
  doCreateOrder: (data) => API.post("api/v1/user/deposit/create-order", data),
  doGetListOrder: () => API.get("api/v1/user/deposit/list-order"),
};

export const WithdrawService = {
  doGetMyOrder: () => API.get("api/v1/user/withdraw/my-order"),
  doCreateOrder: (data) => API.post("api/v1/user/withdraw/create-order", data),
  doCancelOrder: (data) =>
    API.put(`api/v1/user/withdraw/cancel-order/${data?.id}`),
};

export const WalletService = {
  doListWallet: () => API.get("api/v1/user/wallet/list_wallet"),
  doImport: (data) => API.post("api/v1/user/wallet/import", data),
  doCreateWallet: (data) => API.post("api/v1/user/wallet/create_wallet", data),
};

export const QuestionService = {
  doCreateQuestion: (data) =>
    API.post("api/v1/user/question/create-question", data),
  doCreateAnswerQuestion: (data) =>
    API.post("api/v1/user/question/create-answer-question", data),
  doGetAllQuestion: (data = {}) => {
    const { keyword = "", country_id = 0, specialty_id = 0 } = data;
    const keyword_fil = keyword === "" ? "" : `keyword=${keyword}`;
    const country_id_fil = country_id === 0 ? "" : `&country_id=${country_id}`;
    const specialty_id_fil =
      specialty_id === 0 ? "" : `&specialty_id=${specialty_id}`;
    const query = [keyword_fil, country_id_fil, specialty_id_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/question/get-all-question?${query}`
      : `api/v1/user/question/get-all-question`;

    return API.get(url);
  },
  doGetQuestionPending: (data = {}) => {
    const { keyword = "", country_id = 0, specialty_id = 0 } = data;
    const keyword_fil = keyword === "" ? "" : `keyword=${keyword}`;
    const country_id_fil = country_id === 0 ? "" : `&country_id=${country_id}`;
    const specialty_id_fil =
      specialty_id === 0 ? "" : `&specialty_id=${specialty_id}`;

    const query = [keyword_fil, country_id_fil, specialty_id_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/question/get-question-pending?${query}`
      : `api/v1/user/question/get-question-pending`;

    return API.get(url);
  },
  doGetDetailQuestion: (id) =>
    API.get(`api/v1/user/question/detail-question/${id}`),
  doGetListQuestionDoctor: (data = {}) => {
    const { keyword = "", status = 0, specialty_id = 0 } = data;
    const keyword_fil = keyword === "" ? "" : `keyword=${keyword}`;
    const status_fil = status === 0 ? "" : `&status=${status}`;
    const specialty_id_fil =
      specialty_id === 0 ? "" : `&specialty_id=${specialty_id}`;

    const query = [keyword_fil, status_fil, specialty_id_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/question/list-question-doctor?${query}`
      : `api/v1/user/question/list-question-doctor`;

    return API.get(url);
  },
  doGetListQuestionUser: (data = {}) => {
    const { keyword = "", status = 0, specialty_id = 0 } = data;
    const keyword_fil = keyword === "" ? "" : `keyword=${keyword}`;
    const status_fil = status === 0 ? "" : `&status=${status}`;
    const specialty_id_fil =
      specialty_id === 0 ? "" : `&specialty_id=${specialty_id}`;

    const query = [keyword_fil, status_fil, specialty_id_fil]
      .filter(Boolean)
      .join("");

    const url = query
      ? `api/v1/user/question/list-question-user?${query}`
      : `api/v1/user/question/list-question-user`;

    return API.get(url);
  },
};

export const CheckInService = {
  doGetInfo: () => API.get("api/v1/user/daily-check-in/info"),
  doGetDailyCheckIn: () => API.post("api/v1/user/daily-check-in/check-in"),
};

export const BannerService = {
  doGetBanner: () => API.get("api/v1/user/banner/get"),
};

export const VoucherService = {
  doUpdateVoucherDoctor: (data) => {
    const { id, ...dataWithoutId } = data;
    return API.put(
      `api/v1/user/voucher/updateVoucherDoctor/${id}`,
      dataWithoutId
    );
  },
  doGetListVoucherDoctor: (data = {}) => {
    const { keyword = "" } = data;
    const keyword_fil = keyword === "" ? "" : `keyword=${keyword}`;

    const query = [keyword_fil].filter(Boolean).join("");

    const url = query
      ? `api/v1/user/voucher/listVoucherDoctor?limit=9999${query}`
      : `api/v1/user/voucher/listVoucherDoctor?limit=9999`;

    return API.get(url);
  },
  // doGetListVoucherDoctor: (data = {}) =>
  //   API.get("api/v1/user/voucher/listVoucherDoctor?limit=9999"),
  doGetDetailVoucherDoctor: (data) =>
    API.get(`api/v1/user/voucher/detailVoucherDoctor/${data?.id}`),
  doGetListVoucherUser: () => API.get(`api/v1/user/voucher/listVoucherUserWeb`),
  doCreateVoucherDoctor: (data) =>
    API.post("api/v1/user/voucher/createVoucherDoctor", data),

  doDeleteVoucherDoctor: (id) =>
    API.delete(`api/v1/user/voucher/deleteVoucherDoctor/${id}`),
  doBuyVoucherDoctor: (data) =>
    API.post("api/v1/user/voucher/buyVoucherDoctor", data),
  doCheckQueyVoucher: (data) =>
    API.post("api/v1/user/voucher/check-quey-voucher", data),
};

export const NotificationService = {
  doGetListNotification: () =>
    API.get("api/v1/user/booking/order/list-notification?limit=9999"),
  doSeenHistoryDoctor: () =>
    API.post("api/v1/user/booking/order/seen-history-doctor"),
};

export const QRcodeService = {
  doGetCreateQR: (data) =>
    API.get(`api/v1/user/booking/order/create-Qr/${data?.id}`),
  doVerifyQR: (data) => API.post("api/v1/user/booking/order/verify-Qr", data),
};
